import DOMPurify from 'dompurify'

const sanitizerConfig = {
  ALLOWED_TAGS: ['a', 'p', 'div', 'span'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
  ALLOW_DATA_ATTR: true,
  FORBID_TAGS: ['script'],
}

export function sanitizeHTML(rawHtml) {
  return DOMPurify.sanitize(rawHtml, sanitizerConfig)
}

